import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  public nombrePortal = 'BDC';
  public subNombrePortal = 'Biblioteca Digital de Componentes de integración';
  public headerBDCP = true;

  urls = {
    home: environment.homeUrl,
    carpetaciudadana: environment.carpetaciudadanaUrl,
    tramites: environment.tramitesUrl,
    images: environment.imagesUrl,
  };

  public urlRepository: string = environment.repositoryCode.urlBase;

  clickMenuResponsive(event: any) {
    let element = event.target;
    if (element.querySelector('span')) element = element.querySelector('span');

    const body = document.getElementsByTagName('body');
    const buttonElement =  element.parentNode;
    const expanded: any = buttonElement.getAttribute('aria-expanded');

    if (expanded == 'true') {
      element.classList.add('govco-times');
      element.classList.remove('govco-bars');
      body[0].classList.add('scrollNone');
      this.headerBDCP = true;
    } else {
      element.classList.add('govco-bars');
      element.classList.remove('govco-times');
      body[0].classList.remove('scrollNone');
      this.headerBDCP = true;
    }
  }
}
